import { getEnv } from 'env/env';

export const DD_CLIENT_TOKEN = getEnv('NEXT_PUBLIC_DD_CLIENT_TOKEN');
export const DD_APPLICATION_ID = getEnv('NEXT_PUBLIC_DD_APPLICATION_ID');
export const DD_ENV_NAME = getEnv('NEXT_PUBLIC_DD_ENV_NAME');
export const DD_SERVICE_NAME = getEnv('NEXT_PUBLIC_DD_SERVICE_NAME');
export const DD_SITE_URL = getEnv('NEXT_PUBLIC_DD_SITE_URL');
export const DD_RUM_VERSION = getEnv('NEXT_PUBLIC_DD_RUM_VERSION');
export const DD_SESSION_REPLAY_SAMPLE_RATE = getEnv(
  'NEXT_PUBLIC_DD_SESSION_REPLAY_SAMPLE_RATE',
);
